import React, { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import DragCard from "../../../components/drag/GragCard";
import Grid from "@mui/material/Grid";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import { Box } from "@mui/material";
import DropArea from "../../../components/drag/GragCard/DropArea";
import "./taskboard.css";
import StatusColumn from "./StatusColumn";

const TaskBoardDrag = () => {
  const [task, setTask] = useState([
    {
      id: 1,
      moduleName: "Employee Master",
      taskName: "addemployee",
      startDate: "24/06/2024",
      endDate:"23/07/2024",
      hours: "10hrs",
      status: "not",
      priority: "high",
    },
    {
      id: 1,
      moduleName: "Employee Master",
      taskName: "addemployee",
      startDate: "24/06/2024",
      endDate: "23/06/2025",
      hours: "10hrs",
      status: "not",
      priority: "medium",
    },
    {
      id: 1,
      moduleName: "Employee Master",
      taskName: "addemployee",
      startDate: "24/06/2024",
      endDate: "23/08/2024",
      hours: "10hrs",
      status: "not",
      priority: "medium",
    },
    {
      id: 1,
      moduleName: "Employee Master",
      taskName: "addemployee",
      startDate: "24/06/2024",
      endDate: "23/07/2024",
      hours: "10hrs",
      status: "pen",
      priority: "medium",
    },
    {
      id: 1,
      moduleName: "Employee Master",
      taskName: "addemployee",
      startDate: "24/06/2024",
      endDate: "23/07/2024",
      hours: "10hrs",
      status: "com",
      priority: "low",
    },
  ]);
  const [projectTitle, setProjectTitle] = useState("Me Food");
  const [activeCard, setActiveCard] = useState(null);

  const onDrop = (status, postion) => {
    console.log(status, postion, "dfghj");
    if (activeCard == null || activeCard == undefined) return;

    const taskToMove = task[activeCard];
    const updatedTask = task?.filter((task, index) => index !== activeCard);
    updatedTask?.splice(postion, 0, {
      ...taskToMove,
      status: status,
    });
    setTask(updatedTask);
  };
  return (
    <DashboardLayout>
      <MaterialBox>
        <h1 className="project-Title">{projectTitle}</h1>
        <Grid container spacing={2}>
          <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
            <StatusColumn
              title="Not Started"
              data={task}
              status="not"
              onDrop={onDrop}
              setActiveCard={setActiveCard}
            />
          </Grid>
          <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
            <StatusColumn
              title="On Going"
              data={task}
              status="pen"
              onDrop={onDrop}
              setActiveCard={setActiveCard}
            />
          </Grid>
          <Grid size={{ md: 4, lg: 4, xs: 5, sm: 3 }}>
            <StatusColumn
              title="Completed"
              data={task}
              status="com"
              onDrop={onDrop}
              setActiveCard={setActiveCard}
            />
          </Grid>
        </Grid>
      </MaterialBox>
    </DashboardLayout>
  );
};

export default TaskBoardDrag;
